<template>
    <div>
        <div>
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {},
        data() {
            return {}

        }
    }
</script>

<style scoped>
    h1 {
        padding-bottom: 2.5rem;
        padding-left: 15px;
        color: black;
        padding-top: 10px;
        font-size: 3rem;
    }
    #icons .phone, .mail, .facebook, .instagram{
        width: 20%;
    }
    a {
        color: white;
    }
    a:hover .iconSource {
        color: #007bff;
    }
</style>
